// src/components/MapSection.js
import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Poprawka: domyślna ikona
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function MapSection() {
  const position = [50.76745667775662, 20.941799717448266]; // np. Widełki

  return (
    <div className="h-[600px] w-full">
      <MapContainer center={position} zoom={13} scrollWheelZoom={false} className="h-full w-full rounded-lg shadow-lg">
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            Tu odbywają się nasze obozy!
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}

export default MapSection;
